import { createContext, useContext } from 'react';

import {
  FacetsSlice,
  GridMetaSlice,
  ProductsSlice,
} from '../types/gridResponses';

// --- Contexts ---

export const ProductsContext = createContext<ProductsSlice | undefined>(
  undefined
);

export const FacetsContext = createContext<FacetsSlice | undefined>(undefined);

export const GridMetaContext = createContext<GridMetaSlice | undefined>(
  undefined
);

// --- Consumer hooks ---

export const useGridProducts = (): ProductsSlice => {
  const context = useContext(ProductsContext);

  if (!context) {
    throw new Error('useGridProducts must be used within a Grid Data Provider');
  }

  return context;
};

export const useGridFacets = (): FacetsSlice => {
  const context = useContext(FacetsContext);

  if (!context) {
    throw new Error('useGridFacets must be used within a Grid Data Provider');
  }

  return context;
};

export const useGridMeta = (): GridMetaSlice => {
  const context = useContext(GridMetaContext);

  if (!context) {
    throw new Error('useGridMeta must be used within a Grid Data Provider');
  }

  return context;
};
